import React, { useState, useEffect } from 'react';
import './App.css';
import Seo from './components/Seo';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Philosophy from './components/Philosophy';
import Agents from './components/Agents';
import Differentiator from './components/Differentiator';
import Process from './components/Process';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const handleScroll = () => {
      // Handle navigation background
      setScrolled(window.scrollY > 50);

      // Handle active section highlighting
      const scrollPos = window.scrollY + 100;
      const sections = document.querySelectorAll('.section');

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionBottom = sectionTop + section.offsetHeight;
        const sectionId = section.getAttribute('id');

        if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
          setActiveSection(sectionId);
        }
      });

      // Trigger animations for elements in viewport
      const animateElements = document.querySelectorAll('.animate-on-scroll');
      animateElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const elementBottom = element.getBoundingClientRect().bottom;

        if (elementTop < window.innerHeight - 100 && elementBottom > 0) {
          element.classList.add('animated');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const smoothScroll = (targetId) => {
    const target = document.getElementById(targetId);
    if (target) {
      const targetPosition = target.offsetTop - 70;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="App">
      <Seo titleKey="seo.title" descriptionKey="seo.description" />
      <Navigation
        scrolled={scrolled}
        activeSection={activeSection}
        onNavigate={smoothScroll}
      />
      <Hero onNavigate={smoothScroll} />
      <Problem />
      <Philosophy />
      <Agents />
      <Differentiator />
      <Process />
      <Team />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
